import React, { useState } from 'react';
import CustomContainer from '../../components/CustomContainer';
import Loader from '../../components/loader/Loader';
import VerticalTabs from '../../components/tabs/VerticalTabs';
import { tabs } from './tabs';
import { useNavigate, useParams } from 'react-router-dom';
import BasicData from './tabs/basic-data/BasicData';
import DivBetween from '../../components/div/DivBetween';
import LightButton from '../../components/button/LightButton';

const DashboardPage = (props) => {
  const [loader, setLoader] = useState(false);
  const [reload, setReload] = useState(false);

  let { id } = useParams();
  const navigate = useNavigate();

  return (
    <>
      <Loader loader={loader} />
      <CustomContainer
        key={id}
        title={
          <DivBetween>
            {id ? 'Domek' : 'Nowy domek'}
            {id && (
              <div>
                <LightButton
                  show={true}
                  onClick={() => navigate(`/house/${id}/details`)}
                >
                  Szczegóły
                </LightButton>
              </div>
            )}
          </DivBetween>
        }
      >
        {!id ? (
          <BasicData />
        ) : (
          <VerticalTabs
            config={{
              defaultActiveKey: 'basicData',
              mountOnEnter: true,
              unmountOnExit: true,
              tabs: tabs,
            }}
          />
        )}
      </CustomContainer>
    </>
  );
};

export default DashboardPage;
